import React, { createContext, useContext } from 'react';
import posthog from 'posthog-js';
import { PRICE_CATEGORY } from '../setting';

type PosthogContextType = {
    capture: (event: string, data?: Record<string, any>) => void;
};

const PosthogContext = createContext<PosthogContextType | undefined>(undefined);

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com';

let posthogInitialized = false;

export const PosthogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    if (POSTHOG_KEY && !posthogInitialized) {
        posthog.init(POSTHOG_KEY, {
            api_host: POSTHOG_HOST,
            autocapture: false,
            capture_pageview: false,
            capture_pageleave: false
        });
        posthogInitialized = true;
    }

    const capture = (event: string, data?: Record<string, any>) => {
        if (!POSTHOG_KEY) {
            return;
        }
        const payload = data ? { ...data } : {};
        payload.url_prefix = PRICE_CATEGORY;
        posthog.capture(event, payload);
    };

    return (
        <PosthogContext.Provider value={{ capture }}>
            {children}
        </PosthogContext.Provider>
    );
};

export const usePosthog = (): PosthogContextType => {
    const context = useContext(PosthogContext);
    if (!context) {
        throw new Error('usePosthog must be used within a PosthogProvider');
    }
    return context;
};
